import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { CustomMaterialModule } from './modules/custom-material/custom-material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { EditNameComponent } from './components/header/edit-name/edit-name.component';
import { PicasaServiceService } from './components/upload/upload-providers-services/picasa-service.service';
// import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ConfirmBackDialogComponent } from './components/upload/confirm-back-popup/confirm-back-dialog.component';
@NgModule({
    declarations: [AppComponent, HeaderComponent, EditNameComponent,ConfirmBackDialogComponent],
    imports: [
        // BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        CustomMaterialModule,
        SharedModule.forRoot(),
        ServiceWorkerModule.register('/ngsw-worker.js', {
            enabled: environment.production,
        }),      
        // InfiniteScrollModule
    ],
    providers: [PicasaServiceService],
    entryComponents: [
        ConfirmBackDialogComponent
      ],
    bootstrap: [AppComponent],
})
export class AppModule {}
